import React from "react";
import "./../../assets/styles/Copyrights.css";

const Copyrights = ({image}) => {
  return <img id="book_copyright_gif" className="selo_copyright" src={image} />;
};

export default Copyrights;
